

import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, DatePicker, Modal, Table } from "antd";
import DeleteModal from "../../../components/modelpopup/DeleteModal";

import SearchBox from "../../../components/SearchBox";
import { Api_Url } from "../../../config/config";
import axios from "axios";
import "./teamlist.css";
import moment from "moment";
import { ErrorToast, SuccessToast } from "../../ToastComponent";
import MyTeamFilterPage from "./MyTeamFilterPage";

const { RangePicker } = DatePicker;
const TeamsList = () => {
  const [data, setData] = useState([]);
  const [requestType, setRequestType] = useState(0);

  const navigate = useNavigate();

  const handleFilter = (a)=>{
    setData(a)
  }

  //Users Activity Api

  //All Activity

  const [ActivityData, setActivityData] = useState([]);
  const [activeTab, setActiveTab] = useState("home");
  const [activeSubTab, SetActiveSubTab] = useState("subActive");
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [loadingTeams, setLoadingTeams] = useState(false);
  const [loadingActivities, setLoadingActivities] = useState(false);
  
  

  const fetchActivityData = async () => {
    setLoadingActivities(true);
    try {
      const userId = JSON.parse(sessionStorage.getItem("user"))?.id;
      let url = `${Api_Url}api/v1/ActivityLog/myself?UserId=${userId}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${
            JSON.parse(sessionStorage.getItem("user")).accessToken
          }`,
        },
      });
      setData(response.data?.data?.activityList);
      setActivityData(response.data?.data?.activityCount);
    } catch (error) {
      console.error(error.message);
    } finally {
      setLoadingActivities(false);
    }
  };

  // console.log("first", selectedStartDate);

  const handleDateStartChange = (e) => {
    const formattedDate = moment(e.target.value).format("DD/MM/YY");
    setSelectedStartDate(formattedDate);
  };
  const handleDateEndChange = (e) => {
    const formattedDate = moment(e.target.value).format("DD/MM/YY");
    setSelectedEndDate(formattedDate);
  };

  const fetchTeamsData = async () => {
    setLoadingTeams(true);
    try {
      const userId = JSON.parse(sessionStorage.getItem("user"))?.id;
      const response = await axios.get(
        `${Api_Url}api/v1/Team/${userId}/team-members`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      setTeamsData(response.data.data);
    } catch (error) {
      console.error(error.message);
    } finally {
      setLoadingTeams(false);
    }
  };

  const handleDownload = async () => {
    const uid = JSON.parse(sessionStorage.getItem("user"))?.id;
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/ActivityLog/download/excel/myself?UserId=${uid}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user"))?.accessToken
            }`,
          },
        }
      );

      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      const link = document.createElement("a");
      link.href = fileURL;
      link.setAttribute("download", `ActivityLog-${uid}.xlsx`);
      document.body.appendChild(link);
      link.click();
      URL.revokeObjectURL(fileURL);
      document.body.removeChild(link);

      SuccessToast("Download Successful");
    } catch (error) {
      ErrorToast("Something went wrong");
    }
  };

  useEffect(() => {
    if (activeTab === "home") {
      fetchActivityData();
    } else if (activeTab === "profile") {
      fetchTeamsData();
    }
  }, [activeTab, requestType, selectedStartDate, selectedEndDate]);

  const [teamsData, setTeamsData] = useState([]);
  const [alldata, setALlData] = useState({});
  const [isModalVisible, setIsModalVisible] = useState(false);

  const MyTeamsActivityFetch = async () => {
    try {
      const userId = JSON.parse(sessionStorage.getItem("user"))?.id;
      const response = await axios.get(
        `${Api_Url}api/v1/Team/${userId}/team-members`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      // console.log("response", response.data)
      setTeamsData(response.data.data);
    } catch (error) {
      return error.message;
    }
  };

  useEffect(() => {
    MyTeamsActivityFetch();
  }, []);


  const handleViewClick = async (record) => {
    console.log(record);

    const urlMap = {
      1: "CollectionVisit",
      2: "AuthorityVisit",
      3: "PropertyVisit",
      4: "BrokerVisit",
      5: "DeskWork",
      6: "Lead",
      7: "FileLogin",
      8: "CollectingIMD",
      9: "OTCClearance",
      10: "EMICollection",
      11: "ChannelPartner",
      12: "MarketingActivity",
      13: "VendorVisit",
      14: "BusinessPd",
      15: "ResidencePd",
      16: "CollectingDocument",
      17: "BankVisit",
      18: "CustomerVisit",
      19: "BTBankVisit",
      20: "LeadGeneration",
      21: "BrandVisibility",
      22: "ActivityToRecruit",
      23: "DutyOn",
      24: "DutyOff",
    };

    const endpoint = urlMap[record.activityId];

    if (endpoint) {
      try {
        const response = await axios.get(
          `${Api_Url}api/v1/${endpoint}/${record.tableId}`,
          {
            headers: {
              Authorization: `Bearer ${
                JSON.parse(sessionStorage.getItem("user")).accessToken
              }`,
            },
          }
        );
        console.log(response.data.data);
        // setALlData(response?.data?.data);
        // setIsModalVisible(true);
        if (endpoint === "BusinessPd") {
          navigate("/buisness-pd");
        } else {
          setALlData(response?.data?.data);
          setIsModalVisible(true);
        }
      } catch (error) {
        console.error(error);
      }
    } else {
      console.log(`No handler for activityId ${record.activityId}`);
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "userName",
      render: (text, record) => (
        <span className="table-avatar">
          <Link to="/profile" className="avatar">
            <img alt="" src={record.selfieUrl} />
          </Link>
          <Link to="/profile">{text}</Link>
        </span>
      ),
    },
    {
      title: "Activity",
      dataIndex: "name",
    },
    {
      title: "Branch Name",
      dataIndex: "branchName",
    },
    {
      title: "Last Activity",
      dataIndex: "",
      render: (text, record) => (
        <span className="table-avatar">
          {moment(record.activityDate).format("MMMM Do YYYY, h:mm:ss a")}
        </span>
      ),
    },
    {
      title: "Location",
      dataIndex: "", // No dataIndex since this column doesn't directly map to a data field
      render: (text, record) => (
        <a
          href={`https://www.google.com/maps?q=${text.latitude},${text.longitude}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <i class="fa-solid fa-location-dot"></i>
        </a>
      ),
    },
    {
      title: "View",
      dataIndex: "actions",
      render: (text, record) => (
        <Button
          className="btn-property"
          onClick={() => handleViewClick(record)}
        >
          <i className="fa-solid fa-eye"></i>
        </Button>
      ),
    },
  ];

  const [date, setDate] = useState(null);

  const handleDate = (e) => {
    setDate(e.target);
    console.log(date);
  };


  // Set Into The Local Storage
  useEffect(() => {
    localStorage.setItem("activeTab", activeTab);
  }, [activeTab]);

  // Set SUb Active Tab in Local Storage

  useEffect(() => {
    localStorage.setItem("SubActiveTab", activeSubTab);
  }, [activeSubTab]);

  // Download button

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col-md-4">
                <h3 className="page-title">Teams</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Teams</li>
                </ul>
              </div>
              <div className="col-md-8 float-end ms-auto">
                <div className="d-flex title-head">
                  <div></div>
                </div>
              </div>
            </div>
          </div>

          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
              <button
                className={`nav-link ${activeTab === "home" ? "active" : ""}`}
                id="home-tab"
                data-bs-toggle="tab"
                data-bs-target="#home"
                type="button"
                role="tab"
                aria-controls="home"
                aria-selected={activeTab === "home"}
                onClick={() => setActiveTab("home")}
              >
                My Activities
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                className={`nav-link ${
                  activeTab === "profile" ? "active" : ""
                }`}
                id="profile-tab"
                data-bs-toggle="tab"
                data-bs-target="#profile"
                type="button"
                role="tab"
                aria-controls="profile"
                aria-selected={activeTab === "profile"}
                onClick={() => setActiveTab("profile")}
              >
                My Teams
              </button>
            </li>
          </ul>

          {/* Outer Tab Who is !st */}

          <div class="tab-content" id="myTabContent">
            <div
              class="tab-pane fade show active"
              id="home"
              role="tabpanel"
              aria-labelledby="home-tab"
            >
              <div className="d-flex justify-content-between">
                <div className="font-weight: 700">My Activities</div>
                {/* <ul class="nav nav-tabs" id="innerHomeTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${
                        activeSubTab === "home-sub-pane1" ? "active" : ""
                      }`}
                      id="home-sub-tab1"
                      data-bs-toggle="tab"
                      data-bs-target="#home-sub-pane1"
                      type="button"
                      role="tab"
                      aria-controls="home-sub-pane1"
                      aria-selected={activeSubTab === "home-sub-pane1"}
                      onClick={() => {
                        SetActiveSubTab("home-sub-pane1");
                        setRequestType(0);
                      }}
                    >
                      Today
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${
                        activeSubTab === "home-sub-pane2" ? "active" : ""
                      }`}
                      id="home-sub-tab2"
                      data-bs-toggle="tab"
                      data-bs-target="#home-sub-pane2"
                      type="button"
                      role="tab"
                      aria-controls="home-sub-pane2"
                      aria-selected={activeSubTab === "home-sub-pane2"}
                      onClick={() => {
                        SetActiveSubTab("home-sub-pane2");
                        setRequestType(1);
                      }}
                    >
                      Week
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${
                        activeSubTab === "home-sub-pane3" ? "active" : ""
                      }`}
                      id="home-sub-tab3"
                      data-bs-toggle="tab"
                      data-bs-target="#home-sub-pane3"
                      type="button"
                      role="tab"
                      aria-controls="home-sub-pane3"
                      aria-selected={activeSubTab === "home-sub-pane3"}
                      onClick={() => {
                        SetActiveSubTab("home-sub-pane3");
                        setRequestType(2);
                      }}
                    >
                      Month
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${
                        activeSubTab === "home-sub-pane4" ? "active" : ""
                      }`}
                      id="home-sub-tab4"
                      data-bs-toggle="tab"
                      data-bs-target="#home-sub-pane4"
                      type="button"
                      role="tab"
                      aria-controls="home-sub-pane4"
                      aria-selected={activeSubTab === "home-sub-pane4"}
                      onClick={() => {
                        SetActiveSubTab("home-sub-pane4");
                        setRequestType(3);
                      }}
                    >
                      Date
                    </button>
                  </li>
                </ul> */}
                <Button type="primary" onClick={handleDownload}>
                  Download
                </Button>
              </div>

              {/* Today Page Data */}
              <div class="tab-content" id="innerHomeTabContent">
                <div
                  class="tab-pane fade show active"
                  id="home-sub-pane1"
                  role="tabpanel"
                  aria-labelledby="home-sub-tab1"
                >
                  <div className="row">
                    <div className="col-md-12">
                      <div className="table-responsive">
                        <div className="container">
                          <div className="row">
                            {ActivityData &&
                              ActivityData.length > 0 &&
                              ActivityData.map((item) => {
                                return (
                                  <>
                                    <div className="col-md-2">
                                      <div class="profile-widget">
                                        <div class="">
                                          <a class="avatar" href="/profile">
                                            <h2>{item.count}</h2>
                                          </a>
                                        </div>
                                        <h4 class="user-name m-t-10 mb-0 text-ellipsis">
                                          <a href="/profile/1">{item?.name}</a>
                                        </h4>
                                      </div>
                                    </div>
                                  </>
                                );
                              })}
                          </div>
                        </div>

                        <SearchBox />
                        <Table
                          className="table-striped"
                          style={{ overflowX: "auto" }}
                          columns={columns}
                          dataSource={data}
                          rowKey={(record) => record.id}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Week Page Data */}
                <div
                  class="tab-pane fade"
                  id="home-sub-pane2"
                  role="tabpanel"
                  aria-labelledby="home-sub-tab2"
                >
                  <div className="row">
                    <div className="col-md-12">
                      <div className="table-responsive">
                        <div className="container">
                          <div className="row">
                            {ActivityData &&
                              ActivityData.length > 0 &&
                              ActivityData.map((item) => {
                                return (
                                  <>
                                    <div className="col-md-2">
                                      <div class="profile-widget">
                                        <div class="">
                                          <a class="avatar" href="/profile">
                                            <h2>{item.count}</h2>
                                          </a>
                                        </div>
                                        <h4 class="user-name m-t-10 mb-0 text-ellipsis">
                                          <a href="/profile/1">{item?.title}</a>
                                        </h4>
                                      </div>
                                    </div>
                                  </>
                                );
                              })}
                          </div>
                        </div>

                        <SearchBox />
                        <Table
                          className="table-striped"
                          style={{ overflowX: "auto" }}
                          columns={columns}
                          dataSource={data}
                          rowKey={(record) => record.id}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Month Page Data */}
                <div
                  class="tab-pane fade"
                  id="home-sub-pane3"
                  role="tabpanel"
                  aria-labelledby="home-sub-tab3"
                >
                  <div className="row">
                    <div className="col-md-12">
                      <div className="table-responsive">
                        <div className="container">
                          <div className="row">
                            {ActivityData &&
                              ActivityData.length > 0 &&
                              ActivityData.map((item) => {
                                return (
                                  <>
                                    <div className="col-md-2">
                                      <div class="profile-widget">
                                        <div class="">
                                          <a class="avatar" href="/profile">
                                            <h2>{item.count}</h2>
                                          </a>
                                        </div>
                                        <h4 class="user-name m-t-10 mb-0 text-ellipsis">
                                          <a href="/profile/1">{item?.title}</a>
                                        </h4>
                                      </div>
                                    </div>
                                  </>
                                );
                              })}
                          </div>
                        </div>

                        <SearchBox />
                        <Table
                          className="table-striped"
                          style={{ overflowX: "auto" }}
                          columns={columns}
                          dataSource={data}
                          rowKey={(record) => record.id}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Date Page Data */}
                <div
                  class="tab-pane fade"
                  id="home-sub-pane4"
                  role="tabpanel"
                  aria-labelledby="home-sub-tab4"
                >
                  <div className="row">
                    <div className="col-md-12">
                      <div className="table-responsive">
                        <div className="mb-3 Cursor d-flex justify-content-between">
                          <div>
                            <label>Start Date: </label>
                            <input
                              type="date"
                              onChange={handleDateStartChange}
                            />
                          </div>
                          <div>
                            <label>End Date: </label>
                            <input type="date" onChange={handleDateEndChange} />
                          </div>
                        </div>

                        <div className="container">
                          <div className="row">
                            {ActivityData &&
                              ActivityData.length > 0 &&
                              ActivityData.map((item) => {
                                return (
                                  <>
                                    <div className="col-md-2">
                                      <div class="profile-widget">
                                        <div class="">
                                          <a class="avatar" href="/profile">
                                            <h2>{item.count}</h2>
                                          </a>
                                        </div>
                                        <h4 class="user-name m-t-10 mb-0 text-ellipsis">
                                          <a href="/profile/1">{item?.title}</a>
                                        </h4>
                                      </div>
                                    </div>
                                  </>
                                );
                              })}
                          </div>
                        </div>

                        <SearchBox />
                        <Table
                          className="table-striped"
                          style={{ overflowX: "auto" }}
                          columns={columns}
                          dataSource={data}
                          rowKey={(record) => record.id}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          

          {/* 2nd TAb Who is My teams */}


          <div
            class="tab-pane fade"
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            <MyTeamFilterPage parentFunctionLeads={handleFilter}/>
            <div className="row">
              {teamsData.length > 0 &&
                teamsData.map((teams) => {
                  return (
                    <div className="col-md-4">
                      <div class="profile-widget">
                        <div class="profile-img">
                          <a class="avatar" href="/profile">
                            <img src={teams.imageUrl} alt="" />
                          </a>
                        </div>
                        <div class="dropdown profile-action">
                          <div class="dropdown-menu dropdown-menu-right">
                            <a
                              class="dropdown-item"
                              data-bs-toggle="modal"
                              data-bs-target="#edit_employee"
                              href="/employees"
                            >
                              <i class="fa fa-pencil m-r-5"></i> Edit
                            </a>
                            <a
                              class="dropdown-item"
                              data-bs-toggle="modal"
                              data-bs-target="#delete"
                              href="/employees"
                            >
                              <i class="fa-regular fa-trash-can m-r-5"></i>{" "}
                              Delete
                            </a>
                          </div>
                        </div>
                        <h4 class="user-name m-t-10 mb-0 text-ellipsis">
                          <a href="/profile/1">
                            {teams.firstName} {teams.lastName}
                          </a>
                        </h4>
                        <div class="small text-muted">{teams.designation}</div>
                        <button
                          className="btn btn-primary"
                          onClick={() =>
                            navigate(`activities/${teams.id}`, {
                              state: { ...teams },
                            })
                          }
                        >
                          Activities
                        </button>
                        <Link
                          to={`https://www.google.com/maps?q=${teams.latitude},${teams.longitude}`}
                        >
                          <button className="btn btn-primary ms-2 changecolor">
                            Tracking ID
                          </button>
                        </Link>
                      </div>

                      {/* <a class="btn btn-success btn-block w-100" href="/marketing-activity"> Search </a> */}
                    </div>
                  );
                })}
            </div>
          </div>

          {/* /Page Header */}
          {/* <ClientsFilter /> */}
        </div>
      </div>
      {/* <ClientModelPopup /> */}
      <DeleteModal Name="Delete Client" />

      <Modal
        title={<h4>Activity Details</h4>}
        open={isModalVisible}
        onOk={() => setIsModalVisible(false)}
        onCancel={() => setIsModalVisible(false)}
        width={600}
        mask={false}
        maskClosable={false}
        closeIcon={<span style={{ color: "red" }}>X</span>}
        footer={null} 
      >
        <div className="modal-body mt-5">
        <div className="container card flex-fill">
          <div className="row">
            <div className="col-12">
              
                <div className="card-body d-flex align-items-center">
                  {alldata?.selfieUrl && (
                    <div className="selfie-container me-3">
                      <img
                        src={alldata.selfieUrl}
                        alt="Selfie"
                        style={{
                          width: "60px",
                          height: "60px",
                          borderRadius: "50%",
                        }}
                      />
                    </div>
                  )}
                  <div>
                    <h1 className="card-title">
                      {alldata?.firstName} {alldata?.lastName} {alldata?.name}
                    </h1>
                    <p className="card-text mb-1">Mobile Nmumber:
                      {alldata?.mobile ? <strong> {alldata?.mobile} </strong>: ""}
                    </p>
                    <p className="card-text mb-1"> Application Number:
                      {alldata?.applicationNo
                        ? <strong> {alldata?.applicationNo}</strong>
                        : ""}
                    </p>
                    <p className="card-text mb-1">Branch Name:
                      {alldata?.branch
                        ? <strong> {alldata?.branch}</strong>
                        : ""}
                    </p>
                    <p className="card-text mb-1">Product Name:
                      {alldata?.product
                        ? <strong> {alldata?.product}</strong>
                        : ""}
                    </p>
                    <p className="card-text mb-1">Source Name:
                      {alldata?.source
                        ? <strong> {alldata?.source}</strong>
                        : ""}
                    </p>
                    <p className="card-text mb-1">Loan Number:
                      {alldata?.loanNumber
                        ? <strong> {alldata?.loanNumber}</strong>
                        : ""}
                    </p>
                    <p className="card-text mb-1">Remark:
                      {alldata?.remark ? <strong> {alldata?.remark}</strong>: ""}
                    </p>
                    <p className="card-text">Created At:
                      {alldata?.created
                        ? <strong> {moment(alldata?.created).format(
                          "MMMM Do YYYY, h:mm:ss a"
                        )}</strong> 
                        : "Creation date not available"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default TeamsList;
